import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardView from '../views/DashboardView.vue'
import ProjectBrowser from '../views/ProjectBrowser.vue'
import ProjectDetail from '../views/ProjectDetail.vue'
import GeneBrowser from '../views/GeneBrowser.vue'
import UploadView from '../views/UploadView.vue'
import DownloadView from '../views/DownloadView.vue'
import DrugTargetAnalysis from '../views/DrugTargetAnalysis.vue'
import AssayImages from '../views/AssayImages.vue'
import ProfileView from '../views/ProfileView.vue'
import FrontPage from '../views/FrontPage.vue'
import VerifyEmail from '../views/VerifyEmail.vue'
import VerifyEmailChange from '../views/VerifyEmailChange.vue'
import ResetPassword from '../views/ResetPassword.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: FrontPage,
    meta: { public: true }
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: VerifyEmail,
    meta: { public: true }
  },
  {
    path: '/verify-email-change',
    name: 'verify-email-change',
    component: VerifyEmailChange,
    meta: { public: true }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword,
    meta: { public: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView
  },
  {
    path: '/projects',
    name: 'projects',
    component: ProjectBrowser,
    duplicateNavigationPolicy: 'ignore'
  },
  {
    path: '/project/:id',
    name: 'project-detail',
    component: ProjectDetail,
    props: true
  },
  {
    path: '/gene-browser',
    name: 'gene-browser',
    component: GeneBrowser,
    meta: { keepAlive: true }
  },
  {
    path: '/drug-target-analysis',
    name: 'drug-target-analysis',
    component: DrugTargetAnalysis,
    meta: { keepAlive: true }
  }
  ,
  {
    path: '/assay-images',
    name: 'assay-images',
    component: AssayImages,
  }
  ,
  {
    path: '/upload',
    name: 'upload',
    component: UploadView
  },
  {
    path: '/download',
    name: 'download',
    component: DownloadView
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView
  },
  {
    path: '/docs',
    name: 'docs',
    component: () => import(/* webpackChunkName: "docs" */ '../views/DocsView.vue'),
    meta: { public: true }
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import(/* webpackChunkName: "faq" */ '../views/FaqView.vue'),
    meta: { public: true }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import(/* webpackChunkName: "feedback" */ '../views/FeedbackView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
